import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { PostWithCommentsAndLikesFragmentDoc } from '../../../../fragments/__generated__/postData.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommunityGroupQueryVariables = Types.Exact<{
  uuid: Types.Scalars['ID']['input'];
  firstPost?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  afterPost?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CommunityGroupQuery = { __typename?: 'Query', group?: { __typename?: 'CommunityGroup', id: string, uuid: string, public: boolean, name: string, description?: string | null, owner: { __typename?: 'User', id: string }, members: Array<{ __typename?: 'User', id: string }>, admins: Array<{ __typename?: 'User', id: string }>, posts?: { __typename?: 'PostConnection', edges: Array<{ __typename?: 'PostEdge', cursor: string, node: { __typename?: 'Post', id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, likes?: Array<{ __typename?: 'PostLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: number, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }, likes?: Array<{ __typename?: 'CommentLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null }>, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type NewPostInCommunitySubscriptionVariables = Types.Exact<{
  communityUuid: Types.Scalars['ID']['input'];
}>;


export type NewPostInCommunitySubscription = { __typename?: 'Subscription', newPostInCommunity?: { __typename?: 'NewPostEdge', cursor: string, node: { __typename?: 'Post', id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, likes?: Array<{ __typename?: 'PostLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: number, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }, likes?: Array<{ __typename?: 'CommentLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null }>, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } } | null };


export const CommunityGroupDocument = gql`
    query CommunityGroup($uuid: ID!, $firstPost: Int, $afterPost: String) {
  group(uuid: $uuid) {
    id
    uuid
    public
    name
    description
    owner {
      id
    }
    members {
      id
    }
    admins {
      id
    }
    posts(first: $firstPost, after: $afterPost) {
      edges {
        cursor
        node {
          ...PostWithCommentsAndLikes
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${PostWithCommentsAndLikesFragmentDoc}`;

/**
 * __useCommunityGroupQuery__
 *
 * To run a query within a React component, call `useCommunityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGroupQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      firstPost: // value for 'firstPost'
 *      afterPost: // value for 'afterPost'
 *   },
 * });
 */
export function useCommunityGroupQuery(baseOptions: Apollo.QueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables> & ({ variables: CommunityGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
      }
export function useCommunityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
        }
// @ts-ignore
export function useCommunityGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<CommunityGroupQuery, CommunityGroupQueryVariables>;
export function useCommunityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<CommunityGroupQuery | undefined, CommunityGroupQueryVariables>;
export function useCommunityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
        }
export type CommunityGroupQueryHookResult = ReturnType<typeof useCommunityGroupQuery>;
export type CommunityGroupLazyQueryHookResult = ReturnType<typeof useCommunityGroupLazyQuery>;
export type CommunityGroupSuspenseQueryHookResult = ReturnType<typeof useCommunityGroupSuspenseQuery>;
export type CommunityGroupQueryResult = Apollo.QueryResult<CommunityGroupQuery, CommunityGroupQueryVariables>;
export const NewPostInCommunityDocument = gql`
    subscription NewPostInCommunity($communityUuid: ID!) {
  newPostInCommunity(input: {uuid: $communityUuid}) {
    cursor
    node {
      ...PostWithCommentsAndLikes
    }
  }
}
    ${PostWithCommentsAndLikesFragmentDoc}`;

/**
 * __useNewPostInCommunitySubscription__
 *
 * To run a query within a React component, call `useNewPostInCommunitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewPostInCommunitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewPostInCommunitySubscription({
 *   variables: {
 *      communityUuid: // value for 'communityUuid'
 *   },
 * });
 */
export function useNewPostInCommunitySubscription(baseOptions: Apollo.SubscriptionHookOptions<NewPostInCommunitySubscription, NewPostInCommunitySubscriptionVariables> & ({ variables: NewPostInCommunitySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewPostInCommunitySubscription, NewPostInCommunitySubscriptionVariables>(NewPostInCommunityDocument, options);
      }
export type NewPostInCommunitySubscriptionHookResult = ReturnType<typeof useNewPostInCommunitySubscription>;
export type NewPostInCommunitySubscriptionResult = Apollo.SubscriptionResult<NewPostInCommunitySubscription>;